<template>
  <section class="product-section">
    <div class="title">
      <h2 class="section-title">{{ $t('homePage.productCenter.title') }}</h2>
      <div class="section-underline"></div>
    </div>
    <div class="product-grid-wrapper">
      <div class="product-grid">
        <div class="product-card" v-for="(item, index) in productTabs" :key="index">
          <div class="product-img-wrapper">
            <router-link :to="{ path: '/product', query: { tab: item.tab } }" exact-active-class="active"
              class="router-link">
              <img :src="item.img" :alt="item.title">
              <div class="product-title">{{ item.title }}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="view-more">
      <router-link :to="{ path: '/product', query: { tab: 0 } }" exact-active-class="active">
        <button class="more-button">{{ $t('homePage.productCenter.viewMore') }}</button>
      </router-link>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
const { tm } = useI18n()

// 从 i18n 配置中读取产品分类数据
const productTabs = computed(() => {
  const tabs = tm('homePage.productCenter.tabs')
  return Array.isArray(tabs) ? tabs : []
})
</script>

<style scoped>
.product-section {
  background: #f7f7f7;
}

.title {
  background: #fff;
  padding-bottom: 30px;
}

.section-title {
  text-align: center;
  font-size: 2.2rem;
  /* 需要完成适配 */
  font-weight: bold;
  margin-top: 90px;
  margin-bottom: 5px;
}

.section-underline {
  width: 80px;
  height: 4px;
  background: #ff7f1a;
  margin: 10px auto 0 auto;
}

.product-grid-wrapper {
  width: 100%;
  padding-left: 12vw;
  padding-right: 12vw;
  padding-top: 40px;
  padding-bottom: 40px;
  box-sizing: border-box;
  margin: 0 auto;
}

.product-grid {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
}

.product-card {
  flex: 1 1 0;
  width: 16vw;
  max-width: 20vw;
  background: #f6f6f6;
  border-radius: 1.2vw;
  box-shadow: 0 0.3vw 1vw rgba(0, 0, 0, 0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: box-shadow 0.3s, transform 0.3s;
  padding: 0;
}

.product-card:first-child {
  margin-left: 0;
}

.product-card:last-child {
  margin-right: 0;
}

.product-card:hover {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.13);
  transform: scale(1.05) translateY(-6px);
}

.product-img-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 4/5;
  overflow: hidden;
}

.product-card img {
  width: 100%;
  height: 100%;
  max-width: 100%;
  object-fit: cover;
  display: block;
}

.product-title {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%) translateY(0);
  width: 100%;
  padding: 10px 0 10px 0;
  font-size: 3rem;
  /* 需要完成适配 */
  font-weight: bold;
  color: #fff;
  text-align: center;
  letter-spacing: 2px;
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 18px;
  pointer-events: none;
}

.view-more {
  padding-top: 40px;
  padding-bottom: 100px;
  text-align: center;
  background: #ffffff;
}

.more-button {
  background: #ff7f1a;
  color: #fff;
  border: none;
  border-radius: 2px;
  padding: 6px 36px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}

.more-button:hover {
  background: #ff6600;
}

.router-link {
  text-decoration: none;
  color: inherit;
}


@media screen and (min-width: 1400px) {
  .section-title {
    font-size: 2.4rem;
    margin-top: 90px;
  }

  .product-title {
    font-size: 2rem;
    padding: 10px 0 30px 0;
  }

  .more-button {
    padding: 6px 36px;
    font-size: 1.1rem;
  }

  .product-grid-wrapper {
    padding-left: 12vw;
    padding-right: 12vw;
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .section-underline {
    width: 80px;
  }

  .view-more {
    padding-top: 40px;
    padding-bottom: 100px;
  }
}

@media screen and (max-width: 1399px) {
  .section-title {
    font-size: 2.2rem;
    margin-top: 70px;
  }

  .product-title {
    font-size: 1.8rem;
    padding: 10px 0 25px 0;
  }

  .more-button {
    padding: 6px 36px;
    font-size: 1rem;
  }

  .product-grid-wrapper {
    padding-left: 10vw;
    padding-right: 10vw;
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .section-underline {
    width: 70px;
  }

  .view-more {
    padding-top: 30px;
    padding-bottom: 80px;
  }
}

@media screen and (max-width: 991px) {
  .section-title {
    font-size: 2rem;
    margin-top: 50px;
  }

  .product-title {
    font-size: 1.4rem;
    padding: 10px 0 20px 0;
  }

  .more-button {
    padding: 6px 36px;
    font-size: 0.9rem;
  }

  .product-grid-wrapper {
    padding-left: 8vw;
    padding-right: 8vw;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .section-underline {
    width: 60px;
  }

  .view-more {
    padding-top: 20px;
    padding-bottom: 70px;
  }
}

@media screen and (max-width: 767px) {
  .section-title {
    font-size: 1.8rem;
    margin-top: 30px;
  }

  .product-title {
    font-size: 1.1rem;
    padding: 10px 0 10px 0;
  }

  .more-button {
    padding: 6px 36px;
    font-size: 0.8rem;
  }

  .product-grid-wrapper {
    padding-left: 6vw;
    padding-right: 6vw;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .section-underline {
    width: 50px;
  }

  .view-more {
    padding-top: 20px;
    padding-bottom: 60px;
  }
}
</style>